export default __webpack_public_path__ + "static/media/paypal.70d38bfa.svg";